export default __webpack_public_path__ + "static/media/file-icon.0ffad6e0.svg";